export default "__VITE_ASSET__CESIbL7K__"